import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useTheme } from "../../contexts/ThemeContext.jsx";

const sizeClasses = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-5 py-2.5 text-base",
};

const AppButton = ({
  children,
  variant = "submit",
  size = "md",
  className = "",
  type = "button",
  ...props
}) => {
  const { theme } = useTheme();
  const reduceMotion = useReducedMotion();

  const variantClasses = {
    submit: `${theme.accentColor} ${theme.buttonHover} text-white border border-indigo-500/35 shadow-[0_12px_28px_-18px_rgba(79,70,229,0.9)]`,
    success:
      "bg-emerald-600 text-white hover:bg-emerald-700 border border-emerald-500/40 shadow-[0_12px_28px_-18px_rgba(5,150,105,0.85)]",
    cancel: "bg-slate-100 text-slate-700 hover:bg-slate-200 border border-slate-300",
    clear: "bg-white/85 text-slate-700 hover:bg-indigo-50 border border-indigo-200/80",
    danger:
      "bg-rose-600 text-white hover:bg-rose-700 border border-rose-500/45 shadow-[0_12px_28px_-18px_rgba(225,29,72,0.85)]",
    ghost:
      "bg-transparent text-slate-700 hover:bg-indigo-50 border border-transparent hover:border-indigo-200",
  };

  return (
    <motion.button
      type={type}
      className={`inline-flex items-center justify-center rounded-xl font-semibold transition-all backdrop-blur-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:opacity-50 disabled:cursor-not-allowed ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      whileHover={reduceMotion ? undefined : { scale: 1.02, y: -1 }}
      whileTap={reduceMotion ? undefined : { scale: 0.98 }}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default AppButton;
